import React from 'react'
import {
  CheckboxInputStyle,
  UncontrolledRadioInput,
} from '@src/components/Inputs'
import { LoadingSpinner } from '../Loaders/LoadingSpinner'
import { PopoverOptionContainer } from '@src/components/BottomSheet/BottomSheet.styles'
import { PlaceSearchLocation } from '../../hooks/useFulfilmentFilter/validation'
import {
  LocationInput,
  LocationInputContainer,
  LocationSearchButton,
  SearchIcon,
} from './LocationSearch.styles'
import { useTranslation } from 'react-i18next'

type LocationSearchWithoutType = Omit<PlaceSearchLocation, 'type'>

interface SearchAddressPlace {
  placeId: string
  address: string
}

export interface LocationSearchProps {
  searchTerm: string
  onSearchTermChange: (value: string) => void
  loading: boolean
  data?: SearchAddressPlace[]
  selectedPlace: LocationSearchWithoutType | null
  onChange: (place: LocationSearchWithoutType) => void
  searchLabel: string
  searchPlaceholder: string
  onSubmit?: () => void
  showSearch?: boolean
}

export const LocationSearch: React.FC<LocationSearchProps> = ({
  searchTerm,
  onSearchTermChange,
  loading,
  data,
  selectedPlace,
  onChange,
  searchLabel,
  onSubmit,
  showSearch = false,
}) => {
  const handleTextInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onSearchTermChange(event.target.value)
  }

  const handleRadioChange = (place: SearchAddressPlace) => {
    onChange({
      placeId: place.placeId,
      address: place.address,
    })
    onSearchTermChange(place.address)
  }

  // Show radio options only if place hasn't been selected or user is typing
  const shouldShowOptions =
    !selectedPlace || searchTerm !== selectedPlace.address

  const { t } = useTranslation('navigation')

  return (
    <>
      <LocationInputContainer>
        <LocationInput
          id="LOCATION"
          type="text"
          name={'search-place'}
          onChange={handleTextInputChange}
          placeholder={searchLabel}
          value={searchTerm}
          required={false}
        />
        {showSearch && (
          <LocationSearchButton
            type="button"
            disabled={!selectedPlace || loading}
            onClick={() => onSubmit && onSubmit()}
          >
            <SearchIcon id="postcode-search-icon" title={t('search')} />
          </LocationSearchButton>
        )}
      </LocationInputContainer>
      {shouldShowOptions && searchTerm && (
        <>
          {loading ? (
            <LoadingSpinner />
          ) : (
            data?.map?.(place => (
              <PopoverOptionContainer key={place.placeId}>
                <UncontrolledRadioInput
                  label={place.address}
                  value={place.placeId}
                  checked={
                    selectedPlace?.placeId === place.placeId &&
                    searchTerm === selectedPlace.address
                  }
                  style={CheckboxInputStyle.TICK}
                  onChange={() => {
                    handleRadioChange(place)
                  }}
                />
              </PopoverOptionContainer>
            ))
          )}
        </>
      )}
    </>
  )
}
